import * as styles from "./styles.css";
import { Typography, Tags, HeaderVariants } from "../../atoms/typography";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Icon, Icons } from "../../atoms/icon";
import { cn } from "@discovery/classnames";
import { getIsMobile } from "../../../utils/isMobile";
import { goBackToPreviousPage } from "../../../utils/common";
export const AppBar = ({ title, container }) => (React.createElement("div", { className: cn(styles.container, container) },
    getIsMobile() && (React.createElement("div", { onClick: goBackToPreviousPage, className: styles.backWrapper },
        React.createElement(Icon, { type: Icons.LeftArrow, className: styles.backButton, color: "white" }))),
    React.createElement("div", { id: "#header" },
        React.createElement(Typography, { classNameM: M.of(styles.name), variant: HeaderVariants.headingFour, tag: Tags.h4 },
            React.createElement(React.Fragment, null, title)))));

